/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum Analyzed_content_typeEnum {
  "JSON" = "JSON",

  "XML" = "XML",

  "STRING" = "STRING"
}

export enum Condition_typeEnum {
  "REGEX" = "REGEX",

  "EQ" = "EQ",

  "NEQ" = "NEQ",

  "LT" = "LT",

  "GT" = "GT",

  "LE" = "LE",

  "GE" = "GE",

  "NULL" = "NULL",

  "ANY" = "ANY"
}

export enum Field_positionEnum {
  "BODY" = "BODY",

  "HEADER" = "HEADER",

  "URL" = "URL"
}

/**
 * The condition applied to the mock rule that a request must respect in order to retrieve the mocked response related to the rule.
 */

// required attributes
const MockConditionR = t.interface({
  analyzed_content_type: enumType<Analyzed_content_typeEnum>(
    Analyzed_content_typeEnum,
    "analyzed_content_type"
  ),

  condition_type: enumType<Condition_typeEnum>(
    Condition_typeEnum,
    "condition_type"
  ),

  field_name: t.string,

  field_position: enumType<Field_positionEnum>(
    Field_positionEnum,
    "field_position"
  ),

  order: t.Integer
});

// optional attributes
const MockConditionO = t.partial({
  condition_value: t.string,

  id: t.string
});

export const MockCondition = t.intersection(
  [MockConditionR, MockConditionO],
  "MockCondition"
);

export type MockCondition = t.TypeOf<typeof MockCondition>;
